module.exports = __webpack_public_path__ + "img/photo-veroniquelesourd-accueil-05.d140a24f.jpeg";